import React, { createContext, ReactNode, useContext, useState } from 'react';

interface FlashContextType {
  flashingSaleRefNums: string[];
  startFlash: (refNum: string) => void;
  stopFlash: (refNum: string) => void;
  isFlashing: (refNum: string) => boolean;
}

const FlashContext = createContext<FlashContextType>({
  flashingSaleRefNums: [],
  startFlash: (_refNum: string) => {
    // default context function
  },
  stopFlash: (_refNum: string) => {
    // default context function
  },
  isFlashing: (_refNum: string) => false,
});

export const useFlashContext = () => useContext(FlashContext);

export const FlashProvider = ({ children }: { children: ReactNode }) => {
  const [flashingSaleRefNums, setFlashingSaleRefNums] = useState<string[]>([]);

  const startFlash = (refNum: string) => {
    setFlashingSaleRefNums((prev) => {
      if (!prev.includes(refNum)) {
        setTimeout(() => {
          setFlashingSaleRefNums((current) => current.filter((r) => r !== refNum));
        }, 2000);

        return [...prev, refNum];

      }

      return prev;

    });
  };

  const stopFlash = (refNum: string) => {
    setFlashingSaleRefNums((prev) => {
      if (prev.includes(refNum)) {
        return prev.filter((r) => r !== refNum);
      }

      return prev;

    });
  };

  const isFlashing = (refNum: string) => flashingSaleRefNums.includes(refNum);

  return (
    <FlashContext.Provider value={{ flashingSaleRefNums, startFlash, stopFlash, isFlashing }}>
      {children}
    </FlashContext.Provider>
  );
};
